import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FormBackButton } from "shared/components/button/FormBackButton";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import {
  FormFooter,
  FormFooterActions,
  FormFooterBreadcrumb,
} from "shared/components/form/FormFooter";
import {
  PageWizardBar,
  usePageWizard,
} from "shared/components/layout/PageWizard";
import { rootRoute } from "shared/navigation/Routes";

export const InvestorTransferSetupFooter: React.FC<{
  fundFamilyId: string;
  allowBack?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  investorTransferId?: string;
  continueButtonText?: string;
}> = ({
  fundFamilyId,
  allowBack,
  isLoading,
  isDisabled,
  continueButtonText,
}) => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  const { navigateBack, canGoNext } = usePageWizard();

  return (
    <FormFooter>
      <FormFooterBreadcrumb>
        <PageWizardBar />
      </FormFooterBreadcrumb>
      <FormFooterActions>
        {allowBack && <FormBackButton onClick={navigateBack} />}
        <FormCancelButton
          onClick={() => {
            navigate(
              rootRoute({})
                .fundFamilies({})
                .fundFamily({ fundFamilyId })
                .commitments({})
                .transfersTab({}).$,
            );
          }}
        >
          {t("common:exit")}
        </FormCancelButton>
        <FormSubmitButton isLoading={isLoading} isDisabled={isDisabled}>
          {continueButtonText ??
            (canGoNext ? t("common:continue") : t("common:finish"))}
        </FormSubmitButton>
      </FormFooterActions>
    </FormFooter>
  );
};
